import { getPageMeta, getSessionCampaignTraits, getProfileData } from './utils';

class SegmentAnalytics {
	constructor(props) {
		this.metaEl = (document.querySelector('[fs-prop="analytics"]') != null) ? getPageMeta() : null;
		this.defaultSpaReferrer = window.location.href;
		this.segmentApiKey = null;

		// tracking functions
		this.trackPage = this.trackPage.bind(this);
		this.trackEvent = this.trackEvent.bind(this);
		this.trackVideoEvent = this.trackVideoEvent.bind(this);
		this.isCanTrackVideo = this.isCanTrackVideo.bind(this);
		this.setSegmentLoaded = this.setSegmentLoaded.bind(this);
		this.initScript = this.initScript.bind(this);

		// data retrieval functions
		this.sportsTypes = this.getSportsTypes();
		this.duration = 0;
		this.secondsViewed = 0;
		this.adCurrentTime = 0;
		this.last_video_length = 0;
		this.current_video_length = 0;
		this.total_length = 0;
		this.getDefaultProps = this.getDefaultProps.bind(this);
		this.getPageProps = this.getPageProps.bind(this);
		this.getEventProps = this.getEventProps.bind(this);
		this.getCategory = this.getCategory.bind(this);
		this.getContentName = this.getContentName.bind(this);
		this.getLandingName = this.getLandingName.bind(this);
		this.getPageName = this.getPageName.bind(this);
		this.getPageType = this.getPageType.bind(this);
		this.getSubCategory = this.getSubCategory.bind(this);
		this.getPageSubType = this.getPageSubType.bind(this);
		this.getStoryTitle = this.getStoryTitle.bind(this);
		this.getPageContentLevels = this.getPageContentLevels.bind(this);
		this.getDuration = this.getDuration.bind(this);
		this.setSecondsViewed = this.setSecondsViewed.bind(this);
		this.getSecondsViewed = this.getSecondsViewed.bind(this);
	}

	getSportsTypes() {
		return [
			'mlb',
			'nfl',
			'nascar',
			'college-football',
			'college-basketball',
			'soccer',
			'ufc',
			'golf',
			'nhl',
			'nba',
			'tennis',
			'boxing',
			'olympics',
			'motor',
			'horse-racing',
			'other',
			'baseball',
			'basketball',
			'bowling',
			'cricket',
			'cycling',
			'football',
			'gymnastics',
			'hockey',
			'mma',
			'rugby',
			'skiing',
			'swimming',
			'volleyball',
			'water-polo',
			'wnba',
			'womens-college-basketball',
			'wrestling',
			'wwe'
		];
	}

	getCategory() {
		return this.metaEl['category'];
	}

	getSubCategory() {
		return this.metaEl['sub_category'];
	}

	getLandingName() {
		let name = this.metaEl['landing_name'];
		if (name) name = name.replace(/\s\s+/g, ' ');
		// CHECK: if page has hash string
		if (window.location.hash) {
			let hash = window.location.hash;
			if (hash.indexOf('nav-option') > -1) {
				name = name.replace('Landing', 'Category');
			}
		}
		return name;
	}

	getPageName() {
		let pageName = this.metaEl ? this.metaEl['seg_page_name'] : ""
		if (pageName) return pageName.replace('::', ':');
	}

	getPageSubType() {
		return this.metaEl ? this.metaEl['page_sub_type'] : "";
	}

	getContentName() {
		return this.metaEl ? this.metaEl['content_name'] : "";
	}

	getStoryTitle() {
		return this.metaEl ? this.metaEl['story_title'] : "";
	}

	getBuildVersion() {
		return this.metaEl ? this.metaEl['build_version'] : "";
	}

	getPageType() {

		let pageType = this.metaEl ? this.metaEl['page_type'] : ""
	
		if (pageType === 'home') return 'section front';

		return pageType;
	}	

	getPageContentLevels(props) {
		if (this.metaEl) { 
			if (this.metaEl.page_content_level_1) props.properties.page_content_level_1 = this.metaEl.page_content_level_1.replace('::', ':');
			if (this.metaEl.page_content_level_2) props.properties.page_content_level_2 = this.metaEl.page_content_level_2.replace('::', ':');
			if (this.metaEl.page_content_level_3) props.properties.page_content_level_3 = this.metaEl.page_content_level_3.replace('::', ':');
			if (this.metaEl.page_content_level_4) props.properties.page_content_level_4 = this.metaEl.page_content_level_4.replace('::', ':');
		} else {
			props.properties.page_content_level_1 = "";
			props.properties.page_content_level_2 = "";
			props.properties.page_content_level_3 = "";
			props.properties.page_content_level_4 = "";
		}


		return props;
	}

	getPosition(position, adTime = 0) {
		return parseInt(position - adTime, 10);
	}

	getDuration(duration) {
		if (duration) {
			duration = parseInt(duration, 10);
			if (duration > 0 && duration != this.duration) this.duration = duration;   
		}
		return this.duration;
	}

	setSecondsViewed(secondsViewed) {
		if (secondsViewed && secondsViewed > 0) this.secondsViewed = secondsViewed;
	}

	getSecondsViewed(eventName) {
		if (eventName.indexOf('Playing') > -1) return 10;
		return Math.floor(this.secondsViewed % 10);
	}

	setCampaignTraits(props) {
		const campaignTraits = getSessionCampaignTraits();

		if (campaignTraits) {
			for(let trait in campaignTraits) {
				props.properties[trait] = campaignTraits[trait];
			}
		}

		return props;
	}

	getDefaultProps(type, eventName) {
		const traits = {
			dcg_profile_id: '',
			appsflyer_id: '',
			network_entitlements_list: '',
			lastKnownProfileId: '',
			lastAnonymousProfileId: '',
			mvpd: '',
		};
		const defaultProps = {
			primary_business_unit: 'fng',
			secondary_business_unit: 'fox sports',
			app_name: 'foxsports.com',
			app_platform: 'web',
			app_version: '',
			app_build: '',
			referrer: this.defaultSpaReferrer,
			page_test_name: '',
			page_timePartingDay: '',
			page_timePartingHour: '',
			campaign_tracking_code: '',
			campaign_organization: '',
			campaign_marketing_channel: '',
			campaign_source: '',
			campaign_name: '',
			campaign_additional: '',
			campaign_agency: '',
			page_name: '',
			page_type: '',
			page_content_level_1: '',
			page_content_level_2: '',
			page_content_level_3: '',
			page_content_level_4: '',
			favorites_length: '',
			favorites_list: '',
			favorites_sports_length: '',
			favorites_sports_list: '',
			favorites_teams_length: '',
			favorites_teams_list: '',
			rivals_sports_length: '',
			rivals_sports_list: '',
			rivals_teams_length: '',
			rivals_teams_list: '',
			subscriptions_length: '',
			subscriptions_list: '',
			push_enabled: '',
		};

		let props;



		// for page view
		if (type === 'page') {
			props = Object.assign(defaultProps, {
				keywords: '',
				page_content_author: '',
				page_content_original_publish_date: '',
				page_content_major_publish_date: '',
				page_content_modified_date: '',
				page_content_original_publish_time: '',
				page_content_major_publish_time: '',
				page_content_modified_time: '',
				page_content_version: '',
				page_content_title: '',
				page_content_id: '',
				page_content_type: '',
				page_content_type_of_story: '',
				page_content_tags: '',
				page_content_category: '',
				page_content_subcategory: '',
				page_content_language: '',
				page_login_state: '',
				page_content_originator: '',
			});
			return {
				name: '',
				context: {traits: traits},
				properties: props,
			};
		}
		// for event
		if (type === 'video' && eventName) {
			// for video events
			props = Object.assign(defaultProps, this.getVideoEventDefaultProps(eventName));
		} else {
			// for custom/other events
			props = defaultProps;
		}

		return {
			event: eventName || '',
			context: {traits: traits},
			properties: props,
		};
	}

	getVideoEventDefaultProps(eventName){
		// main default props for video events
		let props = {
			session_id: '',
			position: 0,
			total_length: '',
			video_player_state: '',
			video_player_content_type: '',
			video_asset_title: '',
			video_asset_id: '',
			video_channel_group_id: '',
			video_primary_business_unit: 'fng',
			video_secondary_business_unit: 'fox sports',
			video_series_id: '',
			video_series_name: '',
			video_fox_profile: false,
			video_content_length: 86400,
			video_content_type: '',
			video_ad_supported: false,
			video_ad_model: '',
			video_content_length_format: '',
			video_rating: '',
			video_asset_category: '',
			video_genre: '',
			video_season_number: '',
			video_episode_number: '',
			video_tms_id: '',
			video_station_id: '',
			video_network: '',
			video_affiliate_window: '',
			video_authorizing_network: '',
			video_player_type: '',
			video_content_channel: '',
			video_ugc_clip: '',
			video_sports_type: '',
			video_sponsor: '',
			video_screen_layout: '',
			video_airplay: false,
			video_first_air_date: '',
			video_first_digital_date: '',
			video_originator: '',
			video_cross_device_play: false,
			video_cast_source_name: '',
			video_cast_source_platform: '',
			video_cast_source_version: '',
			video_cast_source_build: '',
			video_content_subscription_type: '',
			video_feed: '',
			video_is_resume: false,
			video_is_continuous: false,
			video_is_restart: false,
			video_is_autoplay: false,
			video_is_fullscreen: false,
			video_is_livestream: false,
			video_volume: '',
		};
		// other props, segregated to subtypes (playback, content, ad)
		const subtypesProps = {
			playback: {
				bitrate: '',
				framerate: '',
				livestream: false,
				ad_type: '',
				ad_asset_id: '',
				ad_pod_id: '',
				video_player: '',
				sound: '',
				full_screen: false,
				ad_enabled: true,
				quality: '',
			},
			content: {
				bitrate: '',
				framerate: '',
				livestream: false,
				asset_id: '',
				pod_id: '',
				title: '',
				publisher: '',
				description: '',
				keywords: '',
				season: '',
				episode: '',
				genre: '',
				program: '',
				channel: '',
				full_episode: false,
				airdate: '',
			},
			ad: {
				asset_id: '',
				pod_id: '',
				title: '',
				publisher: '',
				content: null,
				pod_position: '',
				pod_length: '',
				type: '',
				load_type: '',
				video_ad_name: '',
				video_ad_length: '',
				video_ad_id: '',
				video_fw_vcid2: '',
				video_fw_sitesection: '',
				video_ad_break_type: '',
				video_ad_break_name: '',
				video_ad_break_position: '',
				video_ad_pod_id: '',
				video_ad_pod_type: '',
				video_ad_pod_name: '',
				video_ad_pod_position: '',
				video_ad_in_pod_position: '',
				video_ad_campaign_id: '',
				video_ad_creative_id: '',
				video_ad_site_id: '',
				video_ad_placement_id: '',
				video_ad_advertiser: '',
				video_ad_creative_url: '',
			},
		};

		
		switch(eventName){
			case 'Video Playback Seek Started':
				props = Object.assign(props, { seek_position: '' });
				break;
			case 'Video Playback Started':
				props = Object.assign(props, {
					content_asset_ids: '',
					content_pod_ids: ''
				});
				break;
			case 'Video Playback Interrupted':
				props = Object.assign(props, { method: '' });
				break;
			case 'Video Ad Playing':
				props = Object.assign(props, { 
					video_seconds_viewed: 0,
					quartile: null 
				});
				break;
			case 'Video Content Playing':
			case 'Video Content Completed':
				props = Object.assign(props, { video_seconds_viewed: 0 });
				break;
			default: break;
		}
		let subtype = this.getVideoSubType(eventName);

		if (subtype) props = Object.assign(props, subtypesProps[subtype]);

		return props;
	}

	getSegmentEventName(eventName) {
		const eventsEnum = {
			'OnPlaybackStart': 'Video Playback Started',
			'OnPlaybackComplete': 'Video Playback Completed',
			'OnContentStart': 'Video Content Started',
			'OnContentComplete': 'Video Content Completed',
			'OnContentPlaying': 'Video Content Playing',
			// TODO: delete once JW player is implemented 100%
			// TODO: un-comment video ads-related events once its ready for tracking
			// 'OnMediaPlay': 'Video Playback Started',
			// 'OnMediaPause': 'Video Playback Paused',
			// 'OnMediaUnpause': 'Video Playback Resumed',
			// 'OnMediaEnd': 'Video Playback Completed',
			// 'OnMediaBuffer': 'Video Playback Buffer Started',
			// 'OnMediaSeek': 'Video Playback Seek Started',
			// 'OnMediaPlaying': 'Video Content Playing',
			// 'OnMediaStart': 'Video Content Started',
			// 'OnMediaComplete': 'Video Content Completed',
			'OnAdStart': 'Video Ad Started',
			'OnAdPlaying': 'Video Ad Playing',
			'OnAdComplete': 'Video Ad Completed',
			// 'onSeekStart': 'Video Playback Seek Started',
			// 'onSeekComplete': 'Video Playback Seek Completed',
			// videoLoad: 'OnLoadReleaseUrl',
			// videoError: 'OnMediaError',
			// videoLoading: 'OnMediaLoadStart',
			// videoReady: 'OnLoadRelease',
			// videoMute: 'OnMute',
			// playerReady: 'OnPlayerLoaded',
			// playerOverlayUp: 'OnShowPlayOverlay'	
			// playerFullScreen: 'OnShowFullScreen',
			// adPodStart: 'onAdPodStart',
			// adPodComplete: 'onAdPodComplete',
		};

		return (eventsEnum[eventName]) ? eventsEnum[eventName] : null;
	}

	getVideoSubType(eventName) {
		const subTypesEnum = {
			'Video Playback Started': 'playback',
			'Video Playback Paused': 'playback',
			'Video Playback Buffer Started': 'playback',
			'Video Playback Buffer Completed': 'playback',
			'Video Playback Resumed': 'playback',
			'Video Playback Completed': 'playback',
			'Video Playback Interrupted': 'playback',
			'Video Playback Seek Started': 'playback',
			'Video Playback Seek Completed': 'playback',
			'Video Content Started': 'content',
			'Video Content Playing': 'content',
			'Video Content Completed': 'content',
			'Video Ad Started': 'ad',
			'Video Ad Playing': 'ad',
			'Video Ad Completed': 'ad',
			'Video Ad Break Started': 'ad',
			'Video Ad Break Completed': 'ad',
			'Video Ad Paused': 'ad',
			'Video Ad Resumed': 'ad',
		};

		return (subTypesEnum[eventName]) ? subTypesEnum[eventName] : null;
	}

	setGlobalProps(props) {
		const pageName = this.getPageName();
		const pageType = this.getPageType();
		const storyTitle = this.getStoryTitle();
		const buildVersion = this.getBuildVersion();

		if (pageName) props.properties.page_name = pageName;
		if (pageType) props.properties.page_type = pageType;
		if (storyTitle) {
			props.properties.story_title = storyTitle;
			if (props.properties.title) props.properties.title = storyTitle;
			if (props.properties.program) props.properties.program = storyTitle;
		}
		if (buildVersion) {
			props.properties.app_build = buildVersion;
			props.properties.app_version = buildVersion;
		}

		props.context.traits = getProfileData( props.context.traits );

		props = this.getPageContentLevels( props );
		props = this.setCampaignTraits( props );

		return props;
	}

	/**
	 * removes all empty/null custom properties
	 * @param {Object} props - analytics props object
	 * @return {Object} - returns object only if not empty/null
	 */
	updateAllProps(props) {
		let newProperties = {};
		for(let prop in props.properties){
			if(props.properties[prop] || typeof props.properties[prop] === "boolean" || typeof props.properties[prop] === "number"){
				newProperties[prop] = props.properties[prop];
			} 
		}
		props.properties = newProperties;
		return props;
	}

	getPageProps(name, data) {
		let props = this.setGlobalProps( this.getDefaultProps('page') );
		props.name = name || this.getLandingName();

		if (data) {
			if (data.properties) {
				for (let prop in data.properties) {
					props.properties[prop] = data.properties[prop];				
				}
			}
			if (data.context && data.context.traits) {
				for (let trait in data.context.traits) {
					props.context.traits[trait] = data.context.traits[trait];				
				}
			}
		} 
		props = this.updateAllProps(props);
		return props;
	}

	getEventProps(eventName, data) {
		eventName = this.getSegmentEventName(eventName);
		let props = this.setGlobalProps( this.getDefaultProps('event', eventName ) );

		props.event = eventName;

		if (data) {
			if (data.properties) {
				for (let prop in data.properties) {
					props.properties[prop] = data.properties[prop];				
				}
			}
			if (data.context && data.context.traits) {
				for (let trait in data.context.traits) {
					props.context.traits[trait] = data.context.traits[trait];				
				}
			}
		}
		props = this.updateAllProps(props);
		return props;
	}

	getVideoEventProps(eventName, data) {
		let props = this.setGlobalProps( this.getDefaultProps('video', eventName) );

		props.event = eventName;
		props.properties.session_id = data.player.guid;
		props.properties.position = (eventName.indexOf('Started') > -1) ? 0 : this.getPosition(data.player.playerGetPosition(), data.player.priorAdTime);
		this.current_video_length = this.getDuration(data.player.duration);
		if (this.current_video_length != this.last_video_length && data.player.contentType == 'main') {
			this.last_video_length = this.current_video_length;
			this.total_length += this.current_video_length;
		}
		if (this.total_length > 0) props.properties.total_length =  this.total_length;
		if (data.player.options.mode) {
			props.properties.livestream = data.player.isLive;
			if (props.properties.livestream) {
				props.properties.video_content_type = 'LIVE';
			} else {
				props.properties.video_content_type = data.player.options.mode.toUpperCase();
			}
		}
		props.properties.video_fox_profile = (props.context.traits.dcg_profile_id != null);
		props.properties.video_player_state = ((playerState) => {
			if (playerState === 'Started') return 'start';
			if (playerState === 'Completed') return 'end';
			if (playerState === 'Playing') return 'play';
			
			return 'no player state';
		})(eventName.split(/[\s,]+/).pop());
		// conditional props
		if (data.player.contentAssetId) props.properties.content_asset_ids = [data.player.contentAssetId];
		if(data.player.currentId) {
			props.properties.video_asset_id = data.player.currentId;
			props.properties.asset_id = data.player.currentId;
		}
		if (data.player.contentType) props.properties.video_player_content_type = data.player.contentType;
		if (!data.player.isLive && this.current_video_length > 0) {
			props.properties.video_content_length = this.current_video_length;
		}
		props.properties.video_content_length_format = (props.properties.video_content_type && props.properties.video_content_type === 'LIVE') ? 'long-form' : 'short-form';
		if (data.assetInfo.network) props.properties.video_network = data.assetInfo.network;
		if ((this.sportsTypes.indexOf(data.mainVideoData.categoryName.toLowerCase()) > -1)) props.properties.video_sports_type = data.mainVideoData.categoryName;
		if (typeof props.properties.video_seconds_viewed !== 'undefined') {
			props.properties.video_seconds_viewed = this.getSecondsViewed(eventName);
		}

		if (data.event) {
			const event = data.event;
			if (event.chapter) {
				props.properties.pod_id = event.chapter.index + 1 + '';

				if (event.chapters && !data.player.isLive && props.properties.hasOwnProperty('content_pod_ids')) {
					const contentPodIds = event.chapters.map((c, i) => i + 1 + '').slice(event.chapter.index);
					props.properties.content_pod_ids = contentPodIds;
				}
			}

			if (eventName === 'Video Ad Playing') {
				this.adCurrentTime = event.currentTime;
				props.properties.video_seconds_viewed = 1;
			}

			if (eventName === 'Video Ad Completed') {
				this.adCurrentTime = 0;
				props.properties.video_seconds_viewed = 1;
			}
		}

		if (data.data) {
			props.properties.program = data.data.categoryName || props.properties.program;
			props.properties.title = data.data.title || props.properties.title;
		}
		props = this.updateAllProps(props);
		return props;
	}

	setSegmentLoaded(flag) {
		return window.segmentLoaded = flag;
	}
	check() {
		return (typeof window.segmentLoaded === 'undefined') ? false : window.segmentLoaded;
	}

	trackPage(name, props){
		let self = this;
		return new Promise((resolve, reject) => {
			/* https://segment.com/docs/sources/website/analytics.js/#page */

			if (!self.check()) {
				try {
					self.initScript(self.segmentApiKey, false);
				} catch(e) {
					return reject('SEGMENT ANALYTICS !! - Segment Analytics is not initialized');
				}
			}
			const meta = props || self.metaEl;
			if ( !meta ) {
				return reject('SEGMENT ANALYTICS !! - analytics meta tag or props are required and are missing');
			}

			props = self.getPageProps(name, meta);
			name = name || props.name;
			/* NOTE: `trackPage` params takes priority over default/meta values from getPageProps */
			console.debug(`Segment page tracking (${name}): ${JSON.stringify(props)}`);
			window.analytics.page(name, props.properties, { context: props.context});

			resolve();
		});
	}

	isCanTrackVideo(eventName, data) {
		if (eventName === 'Video Ad Playing' && data.event) {
		    return Math.floor(this.adCurrentTime) !== Math.floor(data.event.currentTime);
		}

		return true;
	}

	trackVideoEvent(eventName, data) {
		let self = this;
		return new Promise((resolve, reject) => {
			/* https://segment.com/docs/sources/website/analytics.js/#track */
			if (!self.check()) {
				try {
					self.initScript(self.segmentApiKey, false);
				} catch(e) {
					return reject('SEGMENT ANALYTICS !! - Segment Analytics is not initialized');
				}
			}
			if (!eventName) return reject('SEGMENT ANALYTICS !! - video event name is required');
			if (!data) return reject('SEGMENT ANALYTICS !! - video event data is required');

			eventName = self.getSegmentEventName(eventName);

			if (eventName == null) {
				return reject(`SEGMENT ANALYTICS !! - event(${eventName}) is not recognized as a segment event.`);
			}

			if (!this.isCanTrackVideo(eventName, data)) {
				return resolve();
			}

			let props = self.getVideoEventProps(eventName, data);			
			console.debug(`Segment video event tracking (${eventName}) - ${JSON.stringify(props)}`);
			window.analytics.track(eventName, props.properties, { context: props.context});
			resolve();
		});
	}

	trackEvent(eventName, data) {
		let self = this;
		return new Promise((resolve, reject) => {
			/* https://segment.com/docs/sources/website/analytics.js/#track */
			if (!self.check()) {
				try {
					self.initScript(self.segmentApiKey, false);
				} catch(e) {
					return reject('SEGMENT ANALYTICS !! - Segment Analytics is not initialized');
				}
			}
			if (!eventName) return reject('SEGMENT ANALYTICS !! - event name is required');
			if (!data) return reject('SEGMENT ANALYTICS !! - event data is required');
	
			let props = self.getEventProps(eventName, data);
			console.debug(`Segment event tracking (${eventName}) - ${JSON.stringify(props)}`);
			window.analytics.track(eventName, props.properties, { context: props.context});

			resolve();
		});
	}

	initScript(segmentApiKey = null, enablePageLoadTracking = true) {
		const self = this;

		if (!self.check()) {

			self.segmentApiKey = (function(key) {
				if (typeof key === 'string' && key.length > 0) return key;
				return (self.metaEl && (self.metaEl.hasOwnProperty('segment_api_key') && self.metaEl['segment_api_key'])) ? self.metaEl['segment_api_key'] : null;
			})(segmentApiKey);

			!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="4.0.0";
				window.analytics.load(self.segmentApiKey);
				self.setSegmentLoaded(true);

				if (enablePageLoadTracking) { self.trackPage(); }
			}}();
		}
	}
}

window.SegmentAnalytics = new SegmentAnalytics();

export default window.SegmentAnalytics;
